import React, { Fragment } from 'react';
import { observer } from 'mobx-react';
import { http } from '../../services/HttpInterceptor';
import {
    RouteComponentProps, Link
} from "react-router-dom";
import { toast } from 'react-toastify';
import swal from 'sweetalert';
import { observable } from 'mobx';
import { sessionService } from '../../services/SessionService';

interface IndexUserProps extends RouteComponentProps {
    changeToggle(action?: boolean): void
}
@observer export default class IndexUser extends React.Component<IndexUserProps> {

    @observable private users: any;
    @observable private isLoaded = false;

    componentDidMount() {
        this.props.changeToggle(true);
        this.init();
    }

    init = () => {
        http.post('/api/user/read').then((response) => {
            this.users = response.data.response;
            this.isLoaded = true;
        }).catch((error) => {
            toast.error("Error cargando usuarios");
        });
    }

    render() {
        if (!this.isLoaded) {
            return null;
        }
        return (
            <Fragment>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header card-header-primary">
                                <h4 className="card-title ">Lista de usuarios</h4>
                                <p className="card-category">Lista de usuarios de la aplicacion</p>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-sm-10"></div>
                                    <div className="col-sm-2">
                                        {sessionService.canViewSection("Usuarios.add") &&
                                            <Link to={`/usuarios/nuevo`}>
                                                <button className="btn btn-info btn-lg  pull-right">
                                                    <i className="material-icons">account_circle</i> Nuevo Usuario
                                                <div className="ripple-container"></div>
                                                </button>
                                            </Link>
                                        }
                                    </div>
                                </div>
                                <div className="table-responsive">
                                    <table className="table">
                                        <thead className=" text-primary">
                                            <tr>
                                                <th>Usuario</th>
                                                <th>Nombre</th>
                                                <th>Teléfono</th>
                                                <th>Estado</th>
                                                <th className="text-right">Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this.users.map((user: any, index: any) => {
                                                    return (
                                                        <Fragment key={index}>
                                                            <tr>
                                                                <td>{user.username}</td>
                                                                <td>{user.name}</td>
                                                                <td>{user.phone}</td>
                                                                <td>
                                                                    {user.disabled === 0 || user.disabled === null ? 
                                                                        <span className="badge badge-success">Habilitado</span> : 
                                                                        <span className="badge badge-danger">Deshabilitado</span>
                                                                    }
                                                                </td>
                                                                <td className="td-actions text-right">
                                                                    {sessionService.canViewSection("Usuarios.edit") &&
                                                                        <Link to={`usuarios/${user.id}`}>
                                                                            <button style={{ margin: 5 }} type="button" className="btn btn-success">
                                                                                <i className="material-icons">edit</i>
                                                                            </button>
                                                                        </Link>
                                                                    }
                                                                    {user.id !== "1" && sessionService.canViewSection("Usuarios.delete") &&
                                                                        <button onClick={() => this.deleteUser(user.id, index)} style={{ margin: 5 }} type="button" className="btn btn-danger" >
                                                                            <i className="material-icons">close</i>
                                                                        </button>
                                                                    }
                                                                </td>
                                                            </tr>
                                                        </Fragment>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }

    private deleteUser = (id: any, index: any): void => {
        swal({
            title: "Confirmar acción",
            text: "¿Estas seguro que quieres borrar el usuario?",
            icon: "warning",
            dangerMode: true,
        })
            .then(willDelete => {
                if (willDelete) {
                    const deleteObject = JSON.stringify({
                        id
                    });
                    http.post(`/api/user/delete`, deleteObject)
                        .then((response) => {
                            this.users.splice(index, 1);
                            toast.success("Usuario borrado correctamente");
                        }).catch((error) => {
                            if (error.includes("foreign")) {
                                toast.error("Error al borrar: Registros ligados a este usuario");
                            } else {
                                toast.error("Error borrando usuario");
                            }
                        })
                }
            });
    }
}